import {
    PRODUCTION_REGISTER_GRAY_REPORT_REQUEST,
    PRODUCTION_REGISTER_GRAY_REPORT_SUCCESS,
    PRODUCTION_REGISTER_GRAY_REPORT_FAILURE,
    PRODUCTION_REGISTER_GRAY_FILTER_REPORT_REQUEST,
    PRODUCTION_REGISTER_GRAY_FILTER_REPORT_SUCCESS,
    PRODUCTION_REGISTER_GRAY_FILTER_REPORT_FAILURE
  } from "../types/production-register-gray-report-types";
  
  const initialState = {
    productionGrayReports: {},
    loading: false,
    error: null,
  };
  
  const productionGrayReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case PRODUCTION_REGISTER_GRAY_REPORT_REQUEST, PRODUCTION_REGISTER_GRAY_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case PRODUCTION_REGISTER_GRAY_REPORT_SUCCESS: {
        return {
          ...state,
          productionRegisterGrayReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PRODUCTION_REGISTER_GRAY_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          productionRegisterGrayFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PRODUCTION_REGISTER_GRAY_REPORT_FAILURE, PRODUCTION_REGISTER_GRAY_FILTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default productionGrayReportReducer;
  